import React from 'react';
import type { ShellComponent } from '../../../data/ShellConfig';
import ComponentForm from '../ComponentForm';
import StudioDrawer from './StudioDrawer';

type NewComponentDrawerProps = {
    opened: boolean;
    /** Dismiss / return to the previous drawer. */
    onClose: () => void;
    /** Called with the saved component. */
    onSaved: (component: ShellComponent) => void;
    /** When set, edits an existing component instead of creating a new one. */
    componentId?: string;
};

/**
 * Create or edit a component (image or URL) without leaving the studio. Reuses
 * {@link ComponentForm} wholesale — dropzone, library picker, URL, props — inside
 * the studio drawer, opened nested with a Back affordance. ComponentForm renders
 * its own save action, so no drawer footer here.
 */
const NewComponentDrawer: React.FC<NewComponentDrawerProps> = ({
    opened,
    onClose,
    onSaved,
    componentId,
}) => (
    <StudioDrawer
        opened={opened}
        onClose={onClose}
        onBack={onClose}
        title={componentId ? 'Edit component' : 'New component'}
        size="lg"
    >
        <ComponentForm componentId={componentId} onSaved={onSaved} onClose={onClose} />
    </StudioDrawer>
);

export default NewComponentDrawer;
